<div class="report">

    <app-report-range-selector [initialDateRange]="initialDateRange"
                               [emitInitialDateRange]="true"
                               (selected)="onDateRangeSelected($event)"></app-report-range-selector>

    <br>

    <hr class="!m-0">

    <h5 class="report-type mb-0 text-xs">Board Summary</h5>
    <h2 class="-mt-2 text-xl">
        {{ currentDateRange?.rangeFrom | date: 'shortDate' }} -
        {{ currentDateRange?.rangeTo | date: 'shortDate' }}
    </h2>

    <br>

    <div *ngIf="!dataLoaded || !stats">

        <br>

        <p-progress-spinner
                strokeWidth="4"
                fill="transparent"
                animationDuration=".5s"
                [style]="{ width: '50px', height: '50px' }"/>
    </div>

    <div *ngIf="dataLoaded && stats">

        <hr class="!m-0">

        <br>

        <div class="insight-panels">

            <ng-container *ngFor="let stage of stages">

                <app-totals-insight-panel
                        [title]="stageName(stage) + ' Cards'"
                        [icon]="'fa fa-bars-staggered'"
                        [totals]="statsForStage(stage).card.total"
                        [comparableTotals]="comparableStatsForStage(stage)?.card?.total"
                        [lessIsMore]="stage == 'pending'">
                </app-totals-insight-panel>

            </ng-container>

            <app-totals-insight-panel
                    [title]="'Overdue Cards'"
                    [icon]="'far fa-clock'"
                    [totals]="stats.board.overdue.total"
                    [comparableTotals]="comparableStats?.board?.overdue?.total"
                    [lessIsMore]="true">
            </app-totals-insight-panel>

            <app-totals-insight-panel
                    [title]="'Total Cards'"
                    [icon]="'far fa-layer-group'"
                    [totals]="stats.board.card.total"
                    [comparableTotals]="comparableStats?.board?.card?.total">
            </app-totals-insight-panel>

        </div>

        <br>
        <hr class="!m-0">
        <br>

    </div>
</div>
